// Core
import styled from 'styled-components';

// Component
import { OptionsSelectPosition, OptionsSelectProps } from './OptionsSelect.types';

/*
 * Returns the dropdown positioning styles based on the provided position
 * @param position - Dropdown position (top, bottomLeft or bottomRight)
 * @returns string - CSS styles to position the dropdown
 */
const getPositionStyle = (position?: OptionsSelectPosition): string => {
  let style = 'right: 0; left: auto;';

  if (position === OptionsSelectPosition.top) {
    style = 'left: 0; right: 0; bottom: 100%; top: auto; margin-bottom: 8px;';
  }

  if (position === OptionsSelectPosition.bottomLeft) {
    style = 'left: 0; right: 0;';
  }

  return style;
};

export const Container = styled.ul<
Pick<OptionsSelectProps, 'open'> & { position: OptionsSelectProps['position'] }
>`
  position: absolute;
  ${({ position }) => getPositionStyle(position)}
  z-index: 1;
  min-width: max-content;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.optionsSelect.optionsSelectBorder};
  box-shadow: 0 7px 14px 0 ${({ theme }) => theme.color.optionsSelect.optionsSelectBoxShadow};
  padding: 2px 4px;
  margin: 0;
  overflow: hidden;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  max-height: 0;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.color.optionsSelect.optionsSelectBackground};
  ${({ open }) => open && `
    max-height: 27.857rem;
    visibility: visible;
  `};

  /* Hide scrollbar in Firefox */
  scrollbar-width: none;
  scrollbar-color: transparent transparent;

  /* Hide scrollbar in Microsoft Edge and IE */
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
  };
`;

export const OptionsList = styled.li`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  margin: 2px 0;
  border-radius: 4px;
  transition: background-color 0.3s;
  color: ${({ theme }) => theme.color.optionsSelect.selectedOptionColor};
  gap: 10px;

  :hover {
    background-color:${({ theme }) => theme.color.optionsSelect.optionsBackgroundHover};
  };
`;
